export default "__VITE_ASSET__DRik9HaX__"